import Loader from '@amzn/meridian/loader'
import Row from '@amzn/meridian/row'

export const AppLoader = () => (
  <Row
    alignmentHorizontal="center"
    alignmentVertical="center"
    className="loader"
  >
    <Loader />
  </Row>
)
